import { useEffect } from 'react'
import { TabsProvider, useTabsContext } from './TabsContext'
import type { TabsProps } from './types'
import styles from './Tabs.module.css'

/**
 * Componente principal de abas.
 * Provê o contexto para os componentes filhos (TabsList, Tab, TabPanel).
 */
export function Tabs({
  children,
  defaultTab,
  value,
  onChange,
  syncWithUrl = false,
  basePath = '',
  className,
  id,
}: TabsProps) {
  return (
    <TabsProvider
      defaultTab={defaultTab}
      value={value}
      onChange={onChange}
      syncWithUrl={syncWithUrl}
      basePath={basePath}
      id={id}
    >
      <TabsInner className={className}>{children}</TabsInner>
    </TabsProvider>
  )
}

function TabsInner({ children, className }: { children: React.ReactNode; className?: string }) {
  const { activeTab, tabs, setActiveTab } = useTabsContext()
  
  // Se não há aba ativa e há abas registradas, seleciona a primeira
  useEffect(() => {
    if (!activeTab && tabs.length > 0) {
      const firstEnabledTab = tabs.find((t) => !t.disabled)
      if (firstEnabledTab) {
        setActiveTab(firstEnabledTab.value)
      }
    }
  }, [activeTab, tabs, setActiveTab])
  
  return <div className={[styles.tabs, className].filter(Boolean).join(' ')}>{children}</div>
}
